import React from "react";
import "./styles.css";

export function LoadingInline() {
  return (
    <div className={`lds-ring-inline`}>
      <div />
      <div />
      <div />
      <div />
    </div>
  );
}
